"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ckeditor5React = require("@ckeditor/ckeditor5-react");

var _ckeditor = _interopRequireDefault(require("../../ckeditor5/build/ckeditor"));

var _plaintexttohtml = _interopRequireDefault(require("@ckeditor/ckeditor5-clipboard/src/utils/plaintexttohtml"));

var _radiologia = _interopRequireDefault(require("../../ckeditor5/src/editor/configs/radiologia"));

var _excluded = ["config", "onReady", "id", "maxHeight", "breakLine", "height", "allowImage", "allowTable", "isReadOnly", "useBase64Adapter", "radiologia", "allowPasteFromOffice", "allowHtmlEditor", "atalhos", "mention"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SttCkEditor(props) {
  var config = props.config,
      _onReady = props.onReady,
      id = props.id,
      maxHeight = props.maxHeight,
      breakLine = props.breakLine,
      _props$height = props.height,
      height = _props$height === void 0 ? 250 : _props$height,
      _props$allowImage = props.allowImage,
      allowImage = _props$allowImage === void 0 ? false : _props$allowImage,
      _props$allowTable = props.allowTable,
      allowTable = _props$allowTable === void 0 ? false : _props$allowTable,
      _props$isReadOnly = props.isReadOnly,
      isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly,
      _props$useBase64Adapt = props.useBase64Adapter,
      useBase64Adapter = _props$useBase64Adapt === void 0 ? false : _props$useBase64Adapt,
      _props$radiologia = props.radiologia,
      radiologia = _props$radiologia === void 0 ? false : _props$radiologia,
      _props$allowPasteFrom = props.allowPasteFromOffice,
      allowPasteFromOffice = _props$allowPasteFrom === void 0 ? false : _props$allowPasteFrom,
      _props$allowHtmlEdito = props.allowHtmlEditor,
      allowHtmlEditor = _props$allowHtmlEdito === void 0 ? false : _props$allowHtmlEdito,
      _props$atalhos = props.atalhos,
      atalhos = _props$atalhos === void 0 ? [] : _props$atalhos,
      _props$mention = props.mention,
      mention = _props$mention === void 0 ? [] : _props$mention,
      others = _objectWithoutProperties(props, _excluded);

  var removeTable = allowTable ? [] : ['Table', 'TableProperties', 'TableToolbar'];
  var removeImage = allowImage ? [] : ['Base64UploadAdapter', 'AutoImage', 'ImageUpload', 'Image', 'ImageResizeButtons', 'ImageResizeEditing', 'ImageResizeHandles'];
  var removeHtml = allowHtmlEditor ? [] : ['GeneralHtmlSupport', 'SourceEditing'];
  var editor = useBase64Adapter ? _ckeditor["default"].EditorBase64 : _ckeditor["default"].EditorSimpleUpload;

  if (radiologia) {
    editor.defaultConfig = _radiologia["default"];
  }

  return /*#__PURE__*/_react["default"].createElement(_ckeditor5React.CKEditor, _extends({
    editor: editor
  }, others, {
    disabled: isReadOnly,
    id: id,
    config: _objectSpread(_objectSpread({}, config), {}, {
      atalhos: atalhos,
      mention: {
        feeds: [{
          marker: '#',
          feed: mention
        }]
      },
      removePlugins: removeTable.concat(removeImage).concat(removeHtml),
      isReadOnly: isReadOnly
    }),
    onReady: function onReady(editor) {
      if (editor) {
        // Atualiza a barra de ferramentas para refletir as alterações
        editor.editing.view.change(function (writer) {
          if (breakLine) {
            writer.setStyle("line-break", breakLine, editor.editing.view.document.getRoot());
          }

          if (maxHeight) {
            writer.setStyle("max-height", "".concat(maxHeight, "px"), editor.editing.view.document.getRoot());
            return;
          }

          writer.setStyle("min-height", "".concat(height, "px"), editor.editing.view.document.getRoot());
        });

        if (isReadOnly) {
          var toolbarElement = editor.ui.view.toolbar.element;
          toolbarElement.style.display = 'none';
        } else {
          if (!allowPasteFromOffice) {
            editor.editing.view.document.on('clipboardInput', function (evt, data) {
              var content = (0, _plaintexttohtml["default"])(data.dataTransfer.getData('text/plain'));
              data.content = editor.data.htmlProcessor.toView(content);
            });
          }
        }

        if (_onReady) {
          _onReady(editor);
        }
      }
    }
  }));
}

var _default = SttCkEditor;
exports["default"] = _default;